import { createContext, useReducer, useEffect, useState } from 'react';

export const LanguageContext = createContext();

export const languageReducer = (state, action) => {
  switch (action.type) {
    case 'SET_LANGUAGE':
      return { language: action.payload };
    default:
      return state;
  }
};

export const LanguageContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(languageReducer, {
    language: null
  });
  const [showLanguageSelector, setShowLanguageSelector] = useState(false);

  useEffect(() => {
    // Check if user has already selected a language
    const savedLanguage = localStorage.getItem('preferredLanguage');
    
    if (savedLanguage) {
      dispatch({ type: 'SET_LANGUAGE', payload: savedLanguage });
    } else {
      // Show language selector for first-time visitors
      setShowLanguageSelector(true);
    }
  }, []);

  const setLanguage = (lang) => {
    localStorage.setItem('preferredLanguage', lang);
    dispatch({ type: 'SET_LANGUAGE', payload: lang });
    setShowLanguageSelector(false);
  };

  return (
    <LanguageContext.Provider value={{ ...state, dispatch, setLanguage, showLanguageSelector, setShowLanguageSelector }}>
      {children}
    </LanguageContext.Provider>
  );
};
